/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './dvsn-form-builder-form-detail-element.twig';
import './dvsn-form-builder-form-detail-element.scss';

const { Component, Mixin } = Shopware;

Component.register('dvsn-form-builder-form-detail-element', {
    template,

    inject: [
        'repositoryFactory'
    ],

    mixins: [
        Mixin.getByName('notification')
    ],

    props: {
        element: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            types: [
                { id: 'text', value: 'text', label: this.$t('dvsn-form-builder-form.element.type.text'), fields: ['label', 'mandatory', 'placeholder', 'context'] },
                { id: 'textarea', value: 'textarea', label: this.$t('dvsn-form-builder-form.element.type.textarea'), fields: ['label', 'mandatory', 'placeholder', 'context'] },
                { id: 'select', value: 'select', label: this.$t('dvsn-form-builder-form.element.type.select'), fields: ['label', 'mandatory', 'placeholder', 'selection'] },
                { id: 'checkbox', value: 'checkbox', label: this.$t('dvsn-form-builder-form.element.type.checkbox'), fields: ['label', 'mandatory'] },
                { id: 'image', value: 'image', label: this.$t('dvsn-form-builder-form.element.type.image'), fields: ['label', 'mandatory'] },
                { id: '-', value: '---', label: '---', disabled: true, fields: [] },
                { id: 'salutation', value: 'salutation', label: this.$t('dvsn-form-builder-form.element.type.salutation'), fields: [] },
                { id: 'firstname-lastname', value: 'firstname-lastname', label: this.$t('dvsn-form-builder-form.element.type.firstname-lastname'), fields: ['mandatory'] },
                { id: 'email-phone', value: 'email-phone', label: this.$t('dvsn-form-builder-form.element.type.email-phone'), fields: ['mandatory'] },
                { id: '--', value: '---', label: '---', disabled: true, fields: [] },
                { id: 'title', value: 'title', label: this.$t('dvsn-form-builder-form.element.type.title'), fields: ['label'] },
                { id: 'separator', value: 'separator', label: this.$t('dvsn-form-builder-form.element.type.separator'), fields: [] },
                { id: 'line-break', value: 'line-break', label: this.$t('dvsn-form-builder-form.element.type.line-break'), fields: [] },
                { id: '---', value: '---', label: '---', disabled: true, fields: [] },
                { id: 'content', value: 'content', label: this.$t('dvsn-form-builder-form.element.type.content'), fields: ['options'] },
                { id: 'alert-success', value: 'alert-success', label: this.$t('dvsn-form-builder-form.element.type.alert-success'), fields: ['options'] },
                { id: 'alert-info', value: 'alert-info', label: this.$t('dvsn-form-builder-form.element.type.alert-info'), fields: ['options'] },
                { id: 'alert-warning', value: 'alert-warning', label: this.$t('dvsn-form-builder-form.element.type.alert-warning'), fields: ['options'] },
                { id: 'alert-danger', value: 'alert-danger', label: this.$t('dvsn-form-builder-form.element.type.alert-danger'), fields: ['options'] }
            ],
            currentTypeInfo: this.$t('dvsn-form-builder-form.element.type-info.text'),
            newSelection: ''
        };
    },

    computed: {
        selectionColumns() {
            return [{
                property: 'value',
                dataIndex: 'value',
                label: this.$t('dvsn-form-builder-form.element.card-base.selection.columns.value'),
            }];
        },

        selection() {
            if (this.element.options === null) {
                return [];
            }

            if (this.element.options === '') {
                return [];
            }

            if (this.element.options === undefined) {
                return [];
            }

            const result = this.element.options
                .split(",")
                .map(v => ({ value: v }));

            return result;
        }
    },

    methods: {
        onDeleteSelection(element) {
            const result = this.element.options
                .split(",")
                .filter(v => v.trim() !== element.value)
                .join(",");

            this.element.options = result;
        },

        hasSelection() {
            return this.element?.options != null && this.element.options !== '' && this.element.options !== undefined;
        },

        onAddSelection() {
            const value = this.newSelection.trim();

            if (!value) {
                return;
            }

            const exists = this.selection.some(
                element => element.value === value
            );

            if (exists) {
                this.createNotificationInfo({
                    title: this.$t('dvsn-search-booster-synonym.detail.notifications.duplicate-synonym.title'),
                    message: this.$t('dvsn-search-booster-synonym.detail.notifications.duplicate-synonym.message'),
                });
                return;
            }

            if (this.element.options === null) {
                this.element.options = '';
            }

            if (this.element.options !== '') {
                this.element.options = this.element.options + ',';
            }

            this.element.options = this.element.options + value;
            this.newSelection = '';
        },

        selectType(type) {
            if (this.element.name === '---') {
                if (type !== 'title' && type !== 'separator' && type !== 'line-break') {
                    this.element.name = '';
                }
            }

            if (this.element.name === '') {
                if (type === 'title' || type === 'separator' || type === 'line-break') {
                    this.element.name = '---';
                }
            }

            this.currentTypeInfo = this.$t('dvsn-form-builder-form.element.type-info.' + type);
        },

        onCancel() {
            this.$emit('cancel');
        },

        onClose() {
            this.$emit('cancel');
        },

        onSave() {
            this.element.mandatory = Boolean(this.element.mandatory);

            this.element.name = (this.element.name === undefined || this.element.name === null) ? '' : this.element.name.trim();

            this.element.label = (this.element.label === undefined || this.element.label === null) ? '' : this.element.label.trim();
            this.element.label = (this.element.label === '') ? null : this.element.label;
            this.element.placeholder = (this.element.placeholder === undefined || this.element.placeholder === null) ? '' : this.element.placeholder.trim();
            this.element.placeholder = (this.element.placeholder === '') ? null : this.element.placeholder;
            this.element.context = (this.element.context === undefined || this.element.context === null) ? '' : this.element.context.trim();
            this.element.context = (this.element.context === '') ? null : this.element.context;
            this.element.options = (this.element.options === undefined || this.element.options === null) ? '' : this.element.options.trim();
            this.element.options = (this.element.options === '') ? null : this.element.options;

            if (this.element.name === '') {
                return this.createNotificationError({
                    title: this.$t('dvsn-form-builder-form.element.error-message'),
                    message: this.$t('dvsn-form-builder-form.element.error-invalid-form')
                });
            }

            this.$emit('save');
        },

        displayField(field) {
            let element = null;

            this.types.forEach((currentElement) => {
                if (currentElement.id === this.element.type) {
                    element = currentElement;
                }
            });

            return element.fields.includes(field);
        }
    }
});
